var _style, _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoBodem(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 337.14 470.12",
    style: {
      enableBackground: "new 0 0 337.14 470.12"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F4D26D;}\n\t.st1{fill:#F8AE42;}\n\t.st2{fill:url(#SVGID_1_);}\n\t.st3{fill:#EB5A2B;}\n\t.st4{opacity:0.67;fill:url(#SVGID_00000165913534091737510120000001761111525840826272_);}\n\t.st5{fill:#CB351E;}\n\t.st6{opacity:0.8;fill:url(#SVGID_00000003820346108867652250000002521640588154223009_);}\n\t.st7{fill:#F49422;}\n\t.st8{fill:url(#SVGID_00000115515269716879498780000015439426194040694428_);}\n")), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M75.05,0H0v74.54C45.32,52.11,57.49,23.64,75.05,0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M320.34,114.54C320.17,56.88,273.86,0,188.04,0h-113C57.49,23.64,45.32,52.11,0,74.54v72.81 c57.51-27.79,112.43-68.89,188.51-72.95C229.53,72.21,276.32,90.12,320.34,114.54z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 215.5764,
    y1: 218.0939,
    x2: 76.0085,
    y2: -36.1624
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4419,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5697,
    style: {
      stopColor: "#FCE3C2",
      stopOpacity: 0.2565
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8637,
    style: {
      stopColor: "#F49E29",
      stopOpacity: 0.8464
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9402,
    style: {
      stopColor: "#F28B00"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M320.34,114.54C320.17,56.88,273.86,0,188.04,0h-113C57.49,23.64,45.32,52.11,0,74.54v72.81 c57.51-27.79,112.43-68.89,188.51-72.95C229.53,72.21,276.32,90.12,320.34,114.54z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M297.59,181.12c-54.65-13.4-113.7-14.57-159.85,18.24C64.3,251.59,34.84,264.92,0,265.04v205.07 c121.56,0,51.7-190.5,243.12-253.19C267.16,210.23,284.97,197.16,297.59,181.12z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000003102497205973915340000000907066118757081763_",
    gradientUnits: "userSpaceOnUse",
    x1: 174.8891,
    y1: 430.3064,
    x2: 117.5665,
    y2: 200.319
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2476,
    style: {
      stopColor: "#CFC2C2",
      stopOpacity: 0.2209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8175,
    style: {
      stopColor: "#58292A",
      stopOpacity: 0.7292
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8969,
    style: {
      stopColor: "#471314",
      stopOpacity: 0.8
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.67,
      fill: "url(#SVGID_00000003102497205973915340000000907066118757081763_)"
    },
    d: "M297.59,181.12 c-54.65-13.4-113.7-14.57-159.85,18.24C64.3,251.59,34.84,264.92,0,265.04v205.07c121.56,0,51.7-190.5,243.12-253.19 C267.16,210.23,284.97,197.16,297.59,181.12z"
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M0,470.12h177.98c100.07,0,159.17-67.83,159.17-140.36c0-51.04-28.88-96.04-94.03-112.83 C51.7,279.62,121.56,470.12,0,470.12z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000158707880494045400300000010780825262275434914_",
    gradientUnits: "userSpaceOnUse",
    x1: 377.8719,
    y1: 521.6785,
    x2: 32.9424,
    y2: 273.0279
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8,
      fill: "url(#SVGID_00000158707880494045400300000010780825262275434914_)"
    },
    d: "M0,470.12h177.98 c100.07,0,159.17-67.83,159.17-140.36c0-51.04-28.88-96.04-94.03-112.83C51.7,279.62,121.56,470.12,0,470.12z"
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M137.75,199.36c46.14-32.81,105.19-31.64,159.85-18.24c15.23-19.36,22.76-43.13,22.76-66.27 c0-0.1-0.01-0.2-0.01-0.31c-44.02-24.42-90.81-42.33-131.83-40.15c-76.08,4.06-131,45.16-188.51,72.95v117.7 C34.84,264.92,64.3,251.59,137.75,199.36z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000096755813208710072920000003746671412871018406_",
    gradientUnits: "userSpaceOnUse",
    x1: 162.0589,
    y1: 346.1144,
    x2: 158.1977,
    y2: 25.7848
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3426,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5173,
    style: {
      stopColor: "#EFCDC2",
      stopOpacity: 0.188
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9196,
    style: {
      stopColor: "#C85029",
      stopOpacity: 0.6208
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9653,
    style: {
      stopColor: "#C34117",
      stopOpacity: 0.67
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000096755813208710072920000003746671412871018406_)"
    },
    d: "M137.75,199.36 c46.14-32.81,105.19-31.64,159.85-18.24c15.23-19.36,22.76-43.13,22.76-66.27c0-0.1-0.01-0.2-0.01-0.31 c-44.02-24.42-90.81-42.33-131.83-40.15c-76.08,4.06-131,45.16-188.51,72.95v117.7C34.84,264.92,64.3,251.59,137.75,199.36z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBodem);
export default __webpack_public_path__ + "static/media/logo-bodem.f1765db8f49754e446892a6a76bfbdea.svg";
export { ForwardRef as ReactComponent };